import { PackageConfirmController } from "./package-confirm.controller"
import { PACKAGE_CONTENT_SERVICE_NAME } from "../../../../services/package"
import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"

//#region Asset Imports

import * as TEMPLATE from './package-confirm.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'packageConfirm'

export class PackageConfirmComponent {

    controller = [
        PACKAGE_CONTENT_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        PackageConfirmController]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}